import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { http } from "@/lib/api";

const LINKS = [
  { to: "/privacy", k: "privacy", id: "footer-link-privacy" },
  { to: "/terms", k: "terms", id: "footer-link-terms" },
  { to: "/cookies", k: "cookies", id: "footer-link-cookies" },
  { to: "/contact", k: "contact", id: "footer-link-contact" },
];

export default function PlatformFooter({ dark = false }) {
  const { t } = useTranslation();
  const [p, setP] = useState(null);
  useEffect(() => { http.get("/public/platform-info").then((r) => setP(r.data)).catch(() => {}); }, []);
  const c1 = dark ? "text-slate-400" : "text-slate-500";
  const c2 = dark ? "text-slate-500" : "text-slate-400";
  const lk = dark ? "text-slate-300 hover:text-white" : "text-slate-600 hover:text-[#0F172A]";
  const year = new Date().getFullYear();
  const biz = p?.platform_legal_business_name || "NEXTMIND SOFTWARE DI DE BELLIS DANIELE";
  const vat = p?.platform_vat_number || "14827340960";
  const addr = p?.platform_address || "Via Trento e Trieste 24";
  const cap = p?.platform_postal_code || "20822";
  const city = p?.platform_city || "Seveso";
  const prov = p?.platform_province || "MB";
  const pec = p?.platform_pec || "debellisdaniele91@pec.it";
  return (
    <footer data-testid="platform-footer" className="w-full py-6 px-4 text-center space-y-2">
      <nav aria-label="Legal" className={`flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs font-medium ${lk}`}>
        {LINKS.map((l) => (
          <Link key={l.to} to={l.to} data-testid={l.id} className="underline-offset-4 hover:underline transition-colors">{t(`footer_links.${l.k}`)}</Link>
        ))}
        <a href={`mailto:${pec}`} data-testid="footer-link-support" className="underline-offset-4 hover:underline transition-colors">{t("footer_links.support")}</a>
      </nav>
      <div className={`text-xs ${c1}`}>© {year} NEXTMIND INFISSI · Piattaforma SaaS</div>
      <div className={`text-[11px] ${c2}`} data-testid="footer-legal-name">{biz} · P.IVA {vat}</div>
      <div className={`text-[10px] ${c2}`}>{addr} · {cap} {city} ({prov})</div>
    </footer>
  );
}
